import React from "react";

/**
 * Daily-balance section title: right-aligned "اصلی | فرعی"
 * e.g. درآمد ها | فیس محصلین
 */
const DailyBalanceSectionTitle = ({
  mainTitle,
  subTitle,
  color,
  noPageBreak = false,
}) => {
  return (
    <div
      className={`print-body-title daily-balance-section-title${
        noPageBreak ? " no-section-break" : ""
      }`}
    >
      <h2>
        <span
          className="daily-balance-title-main"
          style={color ? { color } : undefined}
        >
          {mainTitle}
        </span>
        {subTitle ? (
          <>
            <span className="daily-balance-title-sep" aria-hidden="true">
              |
            </span>
            <span className="daily-balance-title-sub">{subTitle}</span>
          </>
        ) : null}
      </h2>
    </div>
  );
};

export default DailyBalanceSectionTitle;
